export const scoreColor = (s) =>
  s >= 80
    ? "bg-emerald-50 text-emerald-700 border-emerald-200"
    : s >= 65
    ? "bg-blue-50 text-blue-700 border-blue-200"
    : s >= 50
    ? "bg-amber-50 text-amber-700 border-amber-200"
    : "bg-red-50 text-red-700 border-red-200";

export const ACCEPT_TYPES =
  ".pdf,.docx,.txt,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain";
